<template>
  <pc-advisor-layout hide-side-navigation>
    <v-container class="pa-0">
      <div class="ma-8 pa-8 no-access-card">
        <h1 class="no-access-heading">{{ heading }}</h1>
        <p class="no-access-subtext">{{ subtext }}</p>

        <pc-button
          filled
          class="mt-6"
          :disabled="!homePath"
          @click="goHome"
          data-id="4f6b2c8e0d7a41539b1e6c0a8d24f7b5"
          >Go to my account</pc-button
        >
      </div>
    </v-container>
  </pc-advisor-layout>
</template>

<script>
import PcAdvisorLayout from "@/advisor/components/layout/PcAdvisorLayout";

export default {
  components: {
    PcAdvisorLayout,
  },

  props: {
    // Worth telling apart: an account that failed to load is not an account the user may not be
    // in, and saying so sends them looking for a permission problem that is not there.
    reason: {
      type: String,
      default: "denied",
    },
  },

  computed: {
    heading() {
      return this.reason === "unavailable"
        ? "We couldn't open this account"
        : "You don't have access to this page";
    },

    subtext() {
      return this.reason === "unavailable"
        ? "Something went wrong on our end. Try again in a moment."
        : "It may belong to an account outside your reach, or the link may be out of date.";
    },

    // The anchor, never the account that was refused: it is the one place the user is always
    // entitled to be.
    homePath() {
      const anchorAccount = this.$store.getters.anchorAccount;

      return anchorAccount ? `/accounts/${anchorAccount.uuid}` : null;
    },
  },

  methods: {
    goHome() {
      if (!this.homePath) return;

      this.$router.push({ path: this.homePath });
    },
  },
};
</script>

<style lang="scss" scoped>
.no-access-card {
  background-color: $white;
}

.no-access-heading {
  font-size: 24px;
  font-weight: 400;
  color: $penChecksDark;
}

.no-access-subtext {
  font-size: 14px;
  color: $penChecksDarkGray;
}
</style>
